import { EMPTY_FIELD } from 'constants/emptyField';

import { Stack } from 'shared/mui/Stack/Stack';
import { Typography } from 'shared/mui/Typography';
import { formatInputInTz } from 'utils/date';

type Props = {
  activityUpdatedAt: number;
};

export const ApiClientsLastActivityInactive: React.FC<Props> = ({ activityUpdatedAt }) => {
  return activityUpdatedAt ? (
    <Stack>
      <Typography variant="body2">{`${formatInputInTz(activityUpdatedAt, { format: 'dd/MM/yyyy' })}`}</Typography>
      <Typography color="secondary.main" variant="body2">
        {`${formatInputInTz(activityUpdatedAt, { format: 'HH:mm' })}`}
      </Typography>
    </Stack>
  ) : (
    EMPTY_FIELD
  );
};
